import React from "react";

import styles from "./CommentList.module.scss";

export type CommentListProps = {
  commentList: {
    student_id: number | undefined;
    full_name: string;
    contents: {
      [x: string]: any;
    };
  }[];
};

const CommentList = ({ commentList }: CommentListProps) => {
  const filteredComments = commentList.filter(
    comment => comment.contents.value,
  );

  return (
    <ul className={styles.commentList}>
      {filteredComments.length > 0 ? (
        filteredComments.map((comment, index) => (
          <li className={styles.comment} key={index}>
            <p className={styles.name}>{comment.full_name}さん</p>
            <p className={styles.text}>{comment.contents.value}</p>
          </li>
        ))
      ) : (
        <li className={styles.comment}>
          <p className={styles.text}>回答データがありません。</p>
        </li>
      )}
    </ul>
  );
};

export default CommentList;
